import React from 'react'
import Link, { withPrefix } from 'gatsby-link'

//  Components
import Button from '../components/Button/Button.js'

class ExhibitTemplate extends React.Component {
  render () {
    const { id, title, url, parentPage } = this.props.pathContext

    return (
      <article>
        {/* { title ? <h1 className="title__page">{ title }</h1> : null } */}
        <div className="section">
          <div className="section__row">
            <div className="section__content">
              <img src={ withPrefix(`/img/exhibits/${ url }-full.png`) } alt="" />
            </div>
          </div>
        </div>
        <div className="section">
          <div className="section__row">
            <div className="section__content">
              <Button to={ parentPage } text="Back" />
            </div>
          </div>
        </div>
      </article>
    )
  }
}

export default ExhibitTemplate


// WEBPACK FOOTER //
// ./src/templates/exhibit.js